import React from 'react'

const Error = () =>(
    <div class="alert alert-warning" role="alert">
        Error al buscar
    </div>
)

export default Error